// extracted by mini-css-extract-plugin
module.exports = {"form":"ChangeAcceptanceDate_form__2E8KY","loadingBtn":"ChangeAcceptanceDate_loadingBtn__2lUif"};